/* src/app/ai-sourcing/ai-sourcing.component.scss */
.job-desc-card {
  border: 1px solid #ffffff;
  background-color: #ffffff;
  padding: 16px;
  color: #969696;
  font-weight: 600;
  margin-bottom: 16px;
  position: relative;
}
.job-desc-card::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 15px;
  left: 50%;
  top: 50px;
  border-right: 1px dashed #484b59;
}
.job-desc-card:last-child::after {
  display: none;
}
.job-desc-card span i {
  margin-right: 10px;
}
.job-desc-card.active {
  border: 1px solid #2e93a1;
  color: #2e93a1;
}
.evaluation-sticky {
  position: sticky;
  top: 110px;
}
.companyCompareStick {
  height: 88vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 55px;
  z-index: 1;
}
.companyCompareStick::-webkit-scrollbar {
  width: 4px;
}
.companyCompareStick:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
.companyCompareStick::-webkit-scrollbar-track {
  background: white !important;
}
.companyCompareStick::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
.companyCompareStick::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
::ng-deep .onscrollStickTop {
  position: sticky;
  top: 0px !important;
  z-index: 2;
  box-shadow: 0 1px 4px 0 rgba(207, 199, 199, 0.5);
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.scroll-sidebar {
  position: sticky;
  top: 80px;
}
/*# sourceMappingURL=ai-sourcing.component-DIWIB3GI.css.map */
